import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoIconModule } from '@fino-ui/icon';
import { FinoInputModule } from '@fino-ui/input';
import { ModalService } from '@fino-ui/modal';
import { FinoSelectModule } from '@fino-ui/select';
import { TranslationModule } from '@fino-ui/translation';
import type { Subscription } from 'rxjs';
import { EMPTY_SUBSCRIPTION } from 'rxjs/internal/Subscription';
import { AppService } from 'src/app/app.service';
import {
  FileUploadModalComponent,
  UPLOAD_TYPES,
} from 'src/app/components/file-upload-modal/file-upload-modal.component';
import { HeaderComponent } from '../../components/header/header.component';
import { MODES, PARENTS } from './create-tenant.constants';
import { CreateTenantService } from './create-tenant.service';

@Component({
  selector: 'app-create-tenant',
  templateUrl: './create-tenant.component.html',
  styleUrl: './create-tenant.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HeaderComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoSelectModule,
    FinoInputModule,
    ButtonModule,
    FinoIconModule,
    TranslationModule,
  ],
})
export class CreateTenantComponent {
  form = new SubmittableForm({
    mode: new FormControl('BOTH', [Validators.required]),
    parent: new FormControl('', [Validators.required]),
    tenant: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    bankCode: new FormControl('', [Validators.required]),
    rzbk: new FormControl(''),
    bic: new FormControl('', [Validators.required]),
    initialContact: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    showArchivingSection: new FormControl(false),
  });

  parents = PARENTS;
  modes = MODES;
  logo: string;
  loadingSub: Subscription = EMPTY_SUBSCRIPTION;

  constructor(
    private ngxModalService: ModalService,
    private createTenantService: CreateTenantService,
    private appService: AppService,
  ) {}

  selectLogo() {
    this.ngxModalService
      .addModal<string>(FileUploadModalComponent, {
        title: 'createTenant.logoUpload.title',
        description: 'createTenant.logoUpload.description',
        fileType: UPLOAD_TYPES.IMAGE,
      })
      .subscribe((result) => {
        if (result) {
          this.logo = result.replace('data:image/png;base64,', '');
        }
      });
  }

  submit() {
    this.form.submit();
    const payload = {
      ...this.form.value,
      logo: this.logo,
    };

    this.loadingSub = this.createTenantService.createTenant(payload).subscribe({
      next: (response: { warnings?: string[] }) => {
        if (response?.warnings?.length) {
          this.appService.error('createTenant.keycloakWarning', {
            warnings: response.warnings.join(', '),
          });
        } else {
          this.appService.success('createTenant.success');
        }
      },
      error: () => {
        this.appService.error('createTenant.error');
      },
    });
  }
}
